import { render, staticRenderFns } from "./Drawer.vue?vue&type=template&id=f5b77210&"
import script from "./Drawer.js?vue&type=script&lang=js&"
export * from "./Drawer.js?vue&type=script&lang=js&"
import style0 from "./Drawer.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports